// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router/router'
import ElementUI from 'element-ui'
import echarts from 'echarts'
import './assets/iconfont/iconfont.css'
import 'element-ui/lib/theme-chalk/index.css'
import './interceptors/ajax.interceptor'
import '../static/global.css'
import httpRequest from './utils/ajax.js'
import messageUtil from './utils/messagebox.js'
import Constants from './components/Constants'
import globalMethods from './utils/globalMethods.js'
import md5 from 'js-md5'

require('es6-promise').polyfill();
require('es6-promise/auto');
Vue.use(ElementUI);
Vue.use(messageUtil);
Vue.use(httpRequest);
Vue.use(globalMethods);
Vue.prototype.$md5 = md5;
Vue.prototype.$echarts = echarts;
Vue.prototype.$constants = Constants;
Vue.config.productionTip = false;

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
});



// WEBPACK FOOTER //
// ./src/main.js